import { Text, Tooltip } from '@mantine/core';
import classes from './OptionTilePicker.module.css';

// One choice out of a few, each drawn rather than described. The drawing is
// the caller's — this owns the tile, the selected state and the behaviour a
// `role="radio"` has to have to deserve the role.
//
// A radiogroup rather than a row of buttons, and `aria-label` carrying the
// option's own words, so anything that found an option by name before the
// control became a picture still finds it.
const OptionTilePicker = ({ value, onChange, label, options }) => (
  <div className={classes.group} role="radiogroup" aria-label={label}>
    {options.map((option) => {
      const selected = value === option.value;

      const tile = (
        <div
          role="radio"
          tabIndex={selected ? 0 : -1}
          aria-checked={selected}
          aria-label={option.label}
          data-selected={selected || undefined}
          className={classes.tile}
          onClick={() => onChange(option.value)}
          onKeyDown={(event) => {
            // A div with a radio role is only a radio if it answers to the
            // keys one answers to.
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              onChange(option.value);
            }
          }}
        >
          {option.glyph}
          <Text size="xs" fw={selected ? 600 : 400} className={classes.label}>
            {option.label}
          </Text>
        </div>
      );

      // The sentence this control replaced, kept where it costs no space.
      return option.hint ? (
        <Tooltip key={option.value} label={option.hint} multiline w={240} withArrow openDelay={300}>
          {tile}
        </Tooltip>
      ) : (
        <span key={option.value}>{tile}</span>
      );
    })}
  </div>
);

export default OptionTilePicker;
